import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { format } from 'date-fns';

interface ScheduleCalendarDisabledDayProps {
  day: Date;
  tooltip?: string;
}

export const ScheduleCalendarDisabledDay: React.FC<ScheduleCalendarDisabledDayProps> = ({
  day,
  tooltip,
}) => {
  const dayNode = (
    <Box
      sx={{
        minHeight: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'default',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: '1rem',
          color: '#D3DBE6',
        }}
      >
        {format(day, 'd')}
      </Typography>
    </Box>
  );

  if (!tooltip) return dayNode;

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      {dayNode}
    </Tooltip>
  );
};
